import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import { useAuth } from 'context/AuthProvider.js';
import { useNavigate } from 'react-router-dom';
import { httpClient } from 'helpers/HttpClient.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import QuejasList from 'pages/Operations/QuejasList.js';
const URI = ApiEndpoint + 'operations/';

const DashboardOpen = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();

  const [dataList, setDataList] = useState([]);
  let history = useNavigate();
  useEffect(() => {
    var authCheck = Auth.getSessionData();
    if (!authCheck || authCheck?.length === 0 || authCheck === 'null') {
      history('/security/login');
      return;
      //Router.push('/login');
    }
  }, []);

  const getQuejasList = async () => {
    setDataList(null);

    httpClient('POST', URI + 'open/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setDataList(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getQuejasList();
  }, []);

  return (
    <>
      {userData && (
        // Se agregó estilo inline para aplicar márgenes y padding interno al Card
        <Card
          className="bg-100 shadow-none border mb-3"
          style={{
            margin: '12px', // Margen externo (separación con otros elementos)
            padding: '16px' // Padding interno (espaciado del contenido hacia adentro)
          }}
        >
          <Card.Header className="py-0" style={{ padding: '8px 0 16px 0' }}>
            <Row>
              <Col md={12}></Col>
            </Row>
          </Card.Header>
          {/* {dataList && (
            <>
              <HeaderStatus
                changeStatus={changeStatus}
                dataSmry={dataSmry}
              ></HeaderStatus>
            </>
          )} */}
          {dataList && (
            <>
              <QuejasList
                subTitle={
                  `Quejas Vigentes y En Proceso: ${dataList.length} Quejas` ||
                  ''
                }
                dataReport={dataList}
              ></QuejasList>
            </>
          )}
        </Card>
      )}
    </>
  );
};

export default DashboardOpen;
